import React, { useState } from 'react';
import { FiFileText } from 'react-icons/fi';
import ContentModal from './ContentModal';
import { fullUrl } from '../api';
import { useLanguage } from '../i18n';

/** Left sidebar: shop articles (desktop only) with click-to-open detail modal. */
export default function ShopSidebarLeft({ articles = [] }) {
  const { t } = useLanguage();
  const [active, setActive] = useState(null);
  const [imgIdx, setImgIdx] = useState(0);

  if (!articles.length) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border dark:border-gray-700 p-4 text-sm text-gray-400">
        <FiFileText className="w-5 h-5 mb-2" />
        {t('noArticles')}
      </div>
    );
  }

  const open = (a) => { setActive(a); setImgIdx(0); };

  const images = (active && active.images) || [];
  const mainImg = images.length ? fullUrl(images[Math.min(imgIdx, images.length - 1)]) : '';

  return (
    <>
      <div className="bg-white dark:bg-gray-800 rounded-xl border dark:border-gray-700 overflow-hidden">
        <div className="px-4 py-3 border-b dark:border-gray-700 flex items-center gap-2 text-sm font-bold">
          <FiFileText className="w-4 h-4" style={{ color: 'var(--primary)' }} />
          {t('articles')}
        </div>
        <div className="divide-y dark:divide-gray-700">
          {articles.map((a) => (
            <button
              key={a.id}
              onClick={() => open(a)}
              className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-900/60 transition-colors anim-fade-up"
            >
              {a.images && a.images.length > 0 && (
                <img src={fullUrl(a.images[0])} alt="" loading="lazy"
                  className="w-full h-28 object-cover rounded-lg mb-2" />
              )}
              <div className="font-semibold text-sm leading-snug line-clamp-2">{a.title}</div>
              {a.description && (
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 line-clamp-3">{a.description}</p>
              )}
              {a.link && (
                <span className="text-xs text-blue-600 break-all line-clamp-1 mt-1 block">{a.link}</span>
              )}
            </button>
          ))}
        </div>
      </div>

      {active && (
        <ContentModal title={active.title} link={active.link} onClose={() => setActive(null)}>
          {images.length > 0 && (
            <div className="space-y-2">
              <img src={mainImg} alt="" className="w-full max-h-[45vh] object-contain rounded-xl bg-gray-50" />
              {images.length > 1 && (
                <div className="flex gap-2 overflow-x-auto no-scrollbar">
                  {images.map((im, i) => (
                    <img key={im} src={fullUrl(im)} alt="" onClick={() => setImgIdx(i)}
                      className={`w-16 h-16 object-cover rounded-lg border-2 cursor-pointer transition ${
                        i === imgIdx ? 'border-[color:var(--primary)]' : 'border-transparent opacity-70 hover:opacity-100'}`} />
                  ))}
                </div>
              )}
            </div>
          )}
          {active.description && (
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{active.description}</p>
          )}
        </ContentModal>
      )}
    </>
  );
}
